import {createAsyncThunk, createSlice} from "@reduxjs/toolkit"
import thunkPromiseHandler from "../../scripts/thunkPromiseHandler"
import axios from "axios"

export const thunks = {
  fetchData: createAsyncThunk("data/fetchData", async (_, thunkAPI) => (
    thunkPromiseHandler(axios.get("/api/data/data"), thunkAPI)
  ))
}

export const {reducer, actions} = createSlice({
  name: "data",
  initialState: {
    data: [],
    isLoading: false
  },
  reducers: {
    // define later
  },
  extraReducers({addCase}) {
    addCase(thunks.fetchData.pending, (state) => {
      state.isLoading = true
    })
    addCase(thunks.fetchData.rejected, (state) => {
      state.isLoading = false
    })
    addCase(thunks.fetchData.fulfilled, (state, {payload: data}) => {
      state.isLoading = false
      state.data = data
    })
  }
})
